module.exports = __webpack_public_path__ + "static/media/profile.67014f93.jpg";